export default {
    loginStatus: false,
    walletInfo: {
        wallet_company: {},
        wallet_person: {},
    },
    userInfo: {},
    safetyVerification: (() => {
        try {
            return JSON.parse(localStorage.getItem('safetyVerification'))
        } catch (err) {
            console.log(err)
            return {}
        }
    })()

};


// WEBPACK FOOTER //
// ./src/vuex/state.js